// Turn a pasted URL into the bare domain for searching:
//   "https://www.example.com/page?x=1" → "example.com"
//   "example.com/" → "example.com", "HTTP://Shop.Example.co.uk:8080" → "shop.example.co.uk"
// Plain search text ("casino", "Home & Garden", an email) is returned as is.
// Parsed by hand rather than with URL(), which would punycode IDNs
// (münchen.de → xn--mnchen-3ya.de) and stop matching the stored name.

const SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

export function extractDomain(input: string): string {
  const raw = input.trim();
  if (!raw) return input;
  const hasScheme = SCHEME.test(raw);
  // Only treat it as a URL when it clearly is one; otherwise leave the text alone.
  const urlLike = hasScheme || /^www\./i.test(raw) || (/^[^\s/?#@]+\.[^\s/?#@]+[/?#]/.test(raw));
  if (!urlLike || /\s/.test(raw)) return input;

  let host = hasScheme ? raw.replace(SCHEME, '') : raw;
  host = host.split(/[/?#]/, 1)[0];          // drop path, query, fragment
  if (hasScheme) host = host.replace(/^[^@]*@/, ''); // drop user:pass@
  host = host.replace(/:\d*$/, '');          // drop :port
  host = host.replace(/\.$/, '').toLowerCase().replace(/^www\./, '');
  return host || input;
}
